import { useState, useEffect } from 'react'

const menuItems = [
  { name: 'Home', href: '/home' },
  { name: 'About', href: '/about' },
  { name: 'Services', href: '/services' },
  { name: 'Research', href: '/research' },
]

interface NavigationMenuProps {
  id: string
  isOpen: boolean
  onClose: () => void
  onNavigate: (href: string) => void
}

export function NavigationMenu({ id, isOpen, onClose, onNavigate }: NavigationMenuProps) {
  const [animationClass, setAnimationClass] = useState('translate-y-[calc(100%+60px)]')

  useEffect(() => {
    if (isOpen) {
      setAnimationClass('translate-y-0')
    } else {
      setAnimationClass('translate-y-[calc(100%+60px)]')
    }
  }, [isOpen])

  return (
    <nav 
      id={id}
      className={`fixed inset-x-0 bottom-[60px] z-50 transition-transform duration-300 ease-in-out backdrop-blur-md bg-[#d6dbdc]/30 dark:bg-black/30 ${animationClass}`}
    >
      <div className="px-12 py-8">
        <ul className="space-y-4">
          {menuItems.map((item) => (
            <li key={item.name}>
              <button
                onClick={() => {
                  onNavigate(item.href)
                  onClose()
                }}
                className="text-xl text-gray-800 hover:text-gray-600 transition-colors font-mono dark:text-gray-200 dark:hover:text-gray-400"
              >
                {item.name}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  )
} 